import axios from 'axios';
import Cookies from 'js-cookie';
import * as actionTypes from './ActionTypes';
import * as commonServiceEndPoint from '../../services/service';
import { commonAPIHandler } from '../../ServerErrorHandler/index';
import userData from './userData.json';
import { useDispatch, useSelector } from 'react-redux';

import { safeWindowOpen } from '../../CommonUtilities/safeWindowOpen';

const serviceEndPoint = '';
const R_PARAM_TB = '';
const R_PARAM_DTL_TB = '';
const sharedActionTypes = '';
let tokenIntervalID = null;
let inactivityTimeOutID = null;
let dispatchObj = null;
export const getCurrentPath = (currentPath) => {
  return {
    type: actionTypes.GET_CURRENT_PATH,
    currentPath: currentPath,
  };
};

export const getSystemParameterSpecificValue = (value) => {
  return (dispatch) => {
    return axios
      .get(
        `${serviceEndPoint.SYSTEM_PARAMETER_SPECIFIC_VALUE}?paramNumber=${value.paramNumber}&functionalArea=${value.functionalArea}
    &lobCode=${value.lobCode}&asOfDate=${value.asOfDate}`
      )
      .then((response) => {
        if (response && response.data) {
          dispatch(getSystemParameterSpecificValueAction(response.data));
        }
      })
      .catch((error) => {
        dispatch(
          getSystemParameterSpecificValueAction({ systemFailure: true })
        );
      });
  };
};
export const getSystemParameterSpecificValueAction = (data) => {
  return {
    type: actionTypes.SYSTEM_PARAMETER_SPECIFIC_VALUE,
    SystemParameterData: data,
  };
};

export const getMaxFrequencyParameter = (value) => {
  return (dispatch) => {
    return axios
      .get(
        `${serviceEndPoint.SYSTEM_PARAMETER_SPECIFIC_VALUE}?paramNumber=${value.paramNumber}&functionalArea=${value.functionalArea}
    &lobCode=${value.lobCode}&asOfDate=${value.asOfDate}`
      )
      .then((response) => {
        if (response && response.data) {
          dispatch(getMaxFrequencyParameterValue(response.data));
        }
      })
      .catch((error) => {
        dispatch(getMaxFrequencyParameterValue({ systemFailure: true }));
      });
  };
};
export const getMaxFrequencyParameterValue = (data) => {
  return {
    type: actionTypes.FREQUENCY_PARAM,
    frequencyParameter: data,
  };
};

export const multiDropDownGetAction = (value) => {
  return (dispatch) => {
    return axios
      .get(`${serviceEndPoint.DROPDOWS}${value}`)
      .then((response) => {
        if (response && response.data) {
          dispatch(multiDropDownGetValues(response.data));
        } else {
          dispatch(multiDropDownGetValues([]));
        }
      })
      .catch((error) => {
        dispatch(multiDropDownGetValues([]));
      });
  };
};

export const getAttachmentsDDValues = (value) => {
  return (dispatch) => {
    return axios
      .get(`${commonServiceEndPoint.DROPDOWNS}`, value)
      .then((response) => {
        if (response && response.data) {
          dispatch(setAttachmentDDValues(response.data));
        } else {
          dispatch(setAttachmentDDValues([]));
        }
      })
      .catch((error) => {
        dispatch(setAttachmentDDValues({ systemFailue: true }));
      });
  };
};
export const getUserDetails = (value) => {
  // export const getUserDetails = (value, password) => {
  return (dispatch) => {
    // return axios.get(`${commonServiceEndPoint.GET_USER_PRIVILEGES}?userId=${value}&password=${password}`)
    return axios
      .get(`${commonServiceEndPoint.GET_USER_PRIVILEGES}?userId=${value}`)
      .then((response) => {
        if (response) {
        }
        dispatch(setUserprivileges(response.data));
      })
      .catch((error) => {
        dispatch(setUserprivileges([]));
        console.log(error);
      });
  };
};

export const multiDropDownGetValues = (data) => {
  return {
    type: actionTypes.MULTI_DROPDOWN_VALUES_ACTION,
    multiDropDownData: data,
  };
};
export const setAttachmentDDValues = (data) => {
  return {
    type: actionTypes.SET_ATTACHMENTS_DDD_VALUES,
    attachmentDDValues: data,
  };
};

export const verifyAddressAPI = (value) => {
  return (dispatch) => {
    return axios
      .post(`${commonServiceEndPoint.ADDRESS_VERIFY}`, value)
      .then((response) => {
        if (response.data) {
          dispatch(setValidAddress(response.data));
        } else {
          dispatch(setValidAddress({ systemFailue: true }));
        }
      })
      .catch((error) => {
        dispatch(setValidAddress({ systemFailue: true }));
      });
  };
};

// export const attachmentAPI = (value) => {
//   const formInfo = new FormData();
//   formInfo.append('file', value[0]);
//   formInfo.append('payoutVO', {});
//   return dispatch => {
//     return axios.post(`${commonServiceEndPoint.ATTACHMENT_ENDPOINT}`, formInfo, {
//       headers: {
//         'content-type': `multipart/form-data; boundary=${formInfo._boundary}`
//       }
//     })
//       .then(response => {
//         if (response.data === undefined) {
//           dispatch(setAttachmentResult([]));
//         } else {
//           dispatch(setAttachmentResult(response.data));
//         }
//       })
//       .catch(error => {
//         console.log(error);
//         dispatch(setAttachmentResult({ systemFailue: true }));
//       });
//   };
// };

export const downloadFileAction = (folder, fileName) => {
  return (dispatch) => {
    return axios
      .get(
        `${commonServiceEndPoint.DOWNLOAD_ACTION_LINK}?folder=${folder}&&fileName=${fileName}`,
        {
          responseType: 'arraybuffer',
          headers: {
            Accept: 'application/octet-stream',
          },
        }
      )
      .then((response) => {
        const sendingResponse = commonAPIHandler(response);
        if (sendingResponse === undefined) {
          dispatch(setDownloadFile({ systemFailure: true }));
        } else {
          const myURL = window.URL || window.webkitURL;
          const objectUrl = myURL.createObjectURL(new Blob([sendingResponse]));
          dispatch(setDownloadFile(objectUrl));
        }
      })
      .catch((error) => {
        console.log(error);
        const sendingResponse = commonAPIHandler(error);
        dispatch(setDownloadFile(sendingResponse));
      });
  };
};

export const downloadPDFPreview = (folder, fileName) => {
  return (dispatch) => {
    return axios
      .get(
        `${commonServiceEndPoint.DOWNLOAD_ACTION_LINK}?folder=${folder}&&fileName=${fileName}`,
        {
          responseType: 'arraybuffer',
          headers: {
            Accept: 'application/octet-stream',
          },
        }
      )
      .then((response) => {
        const sendingResponse = commonAPIHandler(response);
        if (sendingResponse === undefined) {
          dispatch(setDownloadFile({ systemFailure: true }));
        } else {
          const myURL = window.URL || window.webkitURL;
          const objectUrlReview = myURL.createObjectURL(
            new Blob([sendingResponse], { type: 'application/pdf' })
          );
          safeWindowOpen(objectUrlReview, '_blank');
          dispatch(setPDFReview(objectUrlReview));
        }
      })
      .catch((error) => {
        console.log(error);
        const sendingResponse = commonAPIHandler(error);
        dispatch(setPDFReview(sendingResponse));
      });
  };
};

export const setPDFReview = (data) => {
  return {
    type: actionTypes.DOWNLOAD_PDF_FILE_ACTION,
    downloadeFilePDF: data,
  };
};
export const refreshAttachmentsAction = (fcn) => {
  return (dispatch) => {
    return axios
      .get(`${commonServiceEndPoint.REFRESH_ATTACHMENTS_LINK}?fcn=${fcn}`)
      .then((response) => {
        const sendingResponse = commonAPIHandler(response);
        if (sendingResponse === undefined) {
          dispatch(setAttachmnetsAfterRefresh([]));
        } else {
          dispatch(setAttachmnetsAfterRefresh(sendingResponse));
        }
      })
      .catch((error) => {
        console.log(error);
        const sendingResponse = commonAPIHandler(error);
        dispatch(setAttachmnetsAfterRefresh(sendingResponse));
      });
  };
};
export const setAttachmnetsAfterRefresh = (data) => {
  return {
    type: actionTypes.REFRESH_ATTACHMENTS,
    newAttachmentResult: data,
  };
};
export const setDownloadFile = (data) => {
  return {
    type: actionTypes.DOWNLOAD_FILE_ACTION,
    downloadeFile: data,
  };
};
export const setAttachmentResult = (data) => {
  return {
    type: actionTypes.ATTACHMENT_API,
    attachmentResult: data,
  };
};

export const setValidAddress = (data) => {
  return {
    type: actionTypes.ADDRESS_VERIFY,
    addressValidatedData: data,
  };
};
export const setUserprivileges = (data) => {
  return {
    type: actionTypes.USER_LOGGIN_ACTION,
    userPrivileges: data,
  };
};
export const getUserInquiryPrivilege = (data) => {
  return {
    type: actionTypes.USER_INQUIRY_PRIVILEGE,
    userInquiryPrivileges: data,
  };
};
export const setLogInUserID = (data) => {
  return {
    type: actionTypes.LOGIN_USER_ID,
    logInUserID: data ? data.toString().toUpperCase() : data,
  };
};
export const setLoginStateStore = (data) => {
  return {
    type: actionTypes.LOGIN_STATE_STORE,
    logInStateStore: data,
  };
};
export const setPrintLayout = (data) => {
  return {
    type: actionTypes.SET_PRINT_LAYOUT,
    printLayout: data,
  };
};

export const setCGPContactData = (data) => {
  return {
    type: actionTypes.SET_CGP_CONTACT_DATA,
    cgpData: data,
  };
};

export const setGroupContactData = (data) => {
  return {
    type: actionTypes.SET_GROUP_CONTACT_DATA,
    groupData: data,
  };
};

export const setClientContactData = (data) => {
  return {
    type: actionTypes.SET_CLIENT_CONTACT_DATA,
    clientData: data,
  };
};

export const getAuditLogDetailsAction = (
  functionalArea,
  parameterNumber,
  parameterDetailSK,
  isLogDetail,
  auditData
) => {
  let body = {
    tableName: R_PARAM_TB,
    keyValue: {
      r_func_area_cd: functionalArea,
      r_param_num: parameterNumber,
    },
  };
  if (isLogDetail) {
    body = {
      tableName: R_PARAM_DTL_TB,
      keyValue: {
        r_func_area_cd: functionalArea,
        r_param_num: parameterNumber,
        r_param_dtl_sk: parameterDetailSK,
      },
    };
  }

  return (dispatch) => {
    return axios
      .post(`${serviceEndPoint.AUDIT_LOG_ENDPOINT}`, body)
      .then((response) => {
        if (response.data)
          dispatch(
            setAuditLogData(response.data.responseAuditLogDetails, auditData)
          );
      })
      .catch((error) => {
        console.log(error);
      });
  };
};
export const setAuditLogData = (data, keyName) => {
  return {
    type: sharedActionTypes.AUDIT_LOG_TABLE,
    payload: data,
    keyName,
  };
};

export const setAuditLogAccountingData = (data, keyName) => {
  return {
    type: actionTypes.AUDIT_LOG_TABLE_COMMON,
    payload: data,
    keyName,
  };
};

export const getAllClientGroupPlanForCopyContact = () => (dispatch) => {
  return axios
    .post(`${commonServiceEndPoint.GET_ALL_CLIENT_GROUP_PLAN_FOR_COPY_CONTACT}`)
    .then((res) => {
      return dispatch(setCGPContactData(res.data.data));
    })
    .catch((error) => {
      dispatch(setCGPContactData(error));
    });
};

export const getAllClientGroupsForCopyContact = () => (dispatch) => {
  return axios
    .post(`${commonServiceEndPoint.GET_ALL_CLIENT_GROUP_FOR_COPY_CONTACT}`)
    .then((res) => {
      return dispatch(setGroupContactData(res.data.data));
    })
    .catch((error) => {
      dispatch(setGroupContactData(error));
    });
};

export const getAllClientForCopyContact = () => (dispatch) => {
  return axios
    .post(`${commonServiceEndPoint.GET_ALL_CLIENT_FOR_COPY_CONTACT}`)
    .then((res) => {
      return dispatch(setClientContactData(res.data.data));
    })
    .catch((error) => {
      dispatch(setClientContactData(error));
    });
};

export const dispatchLoginUserData = (data) => ({
  type: actionTypes.GET_LOGIN_USER_DATA,
  loginUserData: data,
});


export const loginUserData = async (payload,dispatch) => {
  console.log("login payload",payload);
  return axios
    .post(commonServiceEndPoint.SSO_LOGIN, payload)
    .then((response) => {
      // dispatch(dispatchLoginUserData(response.data));
      return response.data;
      // return userData;
    })
    .catch(() => {
       dispatch(dispatchLoginUserData({ error: 'API failed' }));
    });
};

export const safeLocalStorage = (actType, storeName, data) => {
  let res;
  try {
    if (actType === 'set') {
      res = localStorage.setItem(storeName, data);
    } else if (actType === 'get') {
      res = localStorage.getItem(storeName);
    } else if (actType === 'remove') {
      res = localStorage.removeItem(storeName);
    }
  } catch {}
  return res;
};

export const ssoLogin = (data) => {
  return {
    type: actionTypes.SSO_LOGIN,
    ssoLogin: data,
  };
};

export const setNavigationPrivileges = (data) => {
  return {
    type: actionTypes.SET_NAVIGATION_PRIVILEGES,
    privileges: data,
  };
};

// export const updateUserInOutAction = (status) => {
//   return {
//     type: actionTypes.USER_IN_OUT_ACTION,
//     status: status,
//   };
// };

export const dispatchSessionExpiry = (status) => {
  return {
    type: actionTypes.SHOW_SESSION_EXPIRY_DIALOG,
    status: status,
  };
};

export const dispatchSessionExpand = (status) => {
  return {
    type: actionTypes.SESSION_EXPANDED,
    status: status,
  };
};

export const getKeycloakObj = (value) => {
  return {
    type: actionTypes.KEYCLOAK_OBJ,
    obj: value,
  };
};

export const storeUserAuthorizedRoutes = (value) => {
  return {
    type: actionTypes.STORE_USER_AUTH_ROUTES,
    storedUserAuthorizedRoutes: value,
  };
};

export const stoptUsrInactivityTimeOut = () => {
  clearTimeout(inactivityTimeOutID);
};

export const startUsrInactivityTimeOut = () => {
  inactivityTimeOutID && clearTimeout(inactivityTimeOutID);
  inactivityTimeOutID = setTimeout(() => {
    dispatchObj(dispatchSessionExpiry(true));
  }, eval(process.env.USER_INACTIVITY_TIME)); // process.env.USER_INACTIVITY_TIME
};

// const userInEventHandler = () => {
//   dispatchObj(updateUserInOutAction('IN'));
// };

// const userOutEventHandler = () => {
//   dispatchObj(updateUserInOutAction('OUT'));
// };

// export const checkUserActivity = () => {
//   return (dispatch) => {
//     dispatchObj = dispatch;
//     window.addEventListener('blur', userOutEventHandler);
//     window.addEventListener('focus', userInEventHandler);
//   };
// };

export const setLogInUserInRedux = (val) => {
  return { type: 'LoggedInUser', payload: val };
};

export const tokenInterval = () => {
  return (dispatch) => {
    tokenIntervalID = setTimeout(() => {
      dispatch(
        refreshToken(
          localStorage.getItem('refreshToken'),
          safeLocalStorage('get', 'loginState')
        )
      );
    }, localStorage.getItem('expiresInSeconds') * 1000 - 10000);
  };
};

export const setTokenInStore = (data) => {
  return (dispatch) => {
    localStorage.setItem('accessToken', data.accessToken);
    localStorage.setItem('refreshToken', data.refreshToken);
    localStorage.setItem('expiresInSeconds', data.expiresInSeconds);
    localStorage.setItem('expirationDateTime', data.expirationDateTime);
    if (!localStorage.getItem('lsso')) {
      dispatch(tokenInterval());
    }
  };
};

export const refreshToken = (rToken, userName) => (dispatch) => {
  return axios
    .get(
      `${commonServiceEndPoint.REFRESH_TOKEN}/${
        JSON.parse(userName).logInUserId
      }/${rToken}`
    )
    .then((response) => {
      dispatch(setTokenInStore(response.data));
    })
    .catch((error) => {
      if (error?.message === 'Request failed with status code 401') {
        setTimeout(() => {
          window.location = '/';
        }, 1000);
      }
    });
};

export const setKcRoles = (data) => {
  return {
    type: actionTypes.SET_KC_ROLES,
    payload: data,
  };
};
